export const IconNameMap = {
    AlignBottom: 'AlignBottom',
    AlignDiagonal: 'AlignDiagonal',
    AlignHorizontal: 'AlignHorizontal',
    AlignLeft: 'AlignLeft',
    AlignRight: 'AlignRight',
    AlignTop: 'AlignTop',
    AlignVertical: 'AlignVertical',
    ArrowBottom: 'ArrowBottom',
    ArrowChart: 'ArrowChart',
    ArrowDown: 'ArrowDown',
    ArrowFirst: 'ArrowFirst',
    ArrowLast: 'ArrowLast',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    ArrowSmallBottom: 'ArrowSmallBottom',
    ArrowSmallDown: 'ArrowSmallDown',
    ArrowSmallTop: 'ArrowSmallTop',
    ArrowSmallUp: 'ArrowSmallUp',
    ArrowTop: 'ArrowTop',
    ArrowUp: 'ArrowUp',
    Background: 'Background',
    BackgroundOff: 'BackgroundOff',
    BarCode: 'BarCode',
    Bold: 'Bold',
    Bookmark: 'Bookmark',
    BookmarkFilled: 'BookmarkFilled',
    BookmarkStar: 'BookmarkStar',
    Box: 'Box',
    Box3DRotate: 'Box3DRotate',
    Box3DRotateFill: 'Box3DRotateFill',
    BoxQuestion: 'BoxQuestion',
    Brand: 'Brand',
    building: 'building',
    Bullet: 'Bullet',
    Calculator: 'Calculator',
    CalculatorOff: 'CalculatorOff',
    Calendar: 'Calendar',
    CalendarCross: 'CalendarCross',
    CalendarPlus: 'CalendarPlus',
    Camera: 'Camera',
    Cast: 'Cast',
    Catalog: 'Catalog',
    CatalogFill: 'CatalogFill',
    CatalogPin: 'CatalogPin',
    CatalogPlus: 'CatalogPlus',
    CatalogSearch: 'CatalogSearch',
    CatalogStar: 'CatalogStar',
    ChatText: 'ChatText',
    CheckboxChecked: 'CheckboxChecked',
    CheckboxFilled: 'CheckboxFilled',
    CheckboxFilledChecked: 'CheckboxFilledChecked',
    CheckboxIndetermined: 'CheckboxIndetermined',
    CheckboxUnchecked: 'CheckboxUnchecked',
    Checkmark: 'Checkmark',
    ChevronBackward: 'ChevronBackward',
    ChevronDoubleDown: 'ChevronDoubleDown',
    ChevronDoubleLeft: 'ChevronDoubleLeft',
    ChevronDoubleRight: 'ChevronDoubleRight',
    ChevronDown: 'ChevronDown',
    ChevronDownSmall: 'ChevronDownSmall',
    ChevronFilledDown: 'ChevronFilledDown',
    ChevronFilledLeft: 'ChevronFilledLeft',
    ChevronFilledRight: 'ChevronFilledRight',
    ChevronFilledUp: 'ChevronFilledUp',
    ChevronFilledUpDown: 'ChevronFilledUpDown',
    ChevronForward: 'ChevronForward',
    ChevronLeft: 'ChevronLeft',
    ChevronLeftSmall: 'ChevronLeftSmall',
    ChevronLeftSmallBack: 'ChevronLeftSmallBack',
    ChevronRight: 'ChevronRight',
    ChevronRightSmall: 'ChevronRightSmall',
    ChevronRightSmallForward: 'ChevronRightSmallForward',
    ChevronUp: 'ChevronUp',
    ChevronUpDown: 'ChevronUpDown',
    ChevronUpSmall: 'ChevronUpSmall',
    CircleCheck: 'CircleCheck',
    circleCheckFill: 'circleCheckFill',
    circleEqualFill: 'circleEqualFill',
    circleExclamation: 'circleExclamation',
    circleExclamationFill: 'circleExclamationFill',
    CircleInfo: 'CircleInfo',
    CircleInfoFill: 'CircleInfoFill',
    CirclePieChart: 'CirclePieChart',
    CircleQuestion: 'CircleQuestion',
    circleWarningFill: 'circleWarningFill',
    Clear: 'Clear',
    clock: 'clock',
    Close: 'Close',
    CloseSmall: 'CloseSmall',
    Cog: 'Cog',
    Collapse: 'Collapse',
    ColorPalette: 'ColorPalette',
    Comment: 'Comment',
    CommentOff: 'CommentOff',
    Compare: 'Compare',
    Compas: 'Compas',
    Copy: 'Copy',
    CopyFrom: 'CopyFrom',
    CopyTo: 'CopyTo',
    CornerRadius: 'CornerRadius',
    CrossHair: 'CrossHair',
    CursorDefault: 'CursorDefault',
    CursorPointer: 'CursorPointer',
    CursorPointerFill: 'CursorPointerFill',
    Database: 'Database',
    DimensionHeight: 'DimensionHeight',
    DimensionWidth: 'DimensionWidth',
    DistributeHorizontal: 'DistributeHorizontal',
    DistributeVertical: 'DistributeVertical',
    Division: 'Division',
    Document: 'Document',
    DocumentDoc: 'DocumentDoc',
    DocumentExcel: 'DocumentExcel',
    DocumentIllustrator: 'DocumentIllustrator',
    DocumentPdf: 'DocumentPdf',
    DocumentZip: 'DocumentZip',
    Door: 'Door',
    Download: 'Download',
    Drawing: 'Drawing',
    DrawingOff: 'DrawingOff',
    DropColor: 'DropColor',
    Duplicate: 'Duplicate',
    EllipsesGrab: 'EllipsesGrab',
    Ellipsis: 'Ellipsis',
    EllipsisVertical: 'EllipsisVertical',
    Emoji: 'Emoji',
    Error: 'Error',
    EuroCurrency: 'EuroCurrency',
    ExernalLink: 'ExernalLink',
    Eye: 'Eye',
    EyeDropper: 'EyeDropper',
    eyeOff: 'eyeOff',
    Facebook: 'Facebook',
    Filters: 'Filters',
    Flag: 'Flag',
    FlagFilled: 'FlagFilled',
    Focus: 'Focus',
    Folder: 'Folder',
    FolderPlusFill: 'FolderPlusFill',
    FolderSearch: 'FolderSearch',
    Fullscreen: 'Fullscreen',
    Ghost: 'Ghost',
    GlobeWorld: 'GlobeWorld',
    GlobeWorldEarth: 'GlobeWorldEarth',
    Google: 'Google',
    Grid: 'Grid',
    Group: 'Group',
    Heart: 'Heart',
    HeartFill: 'HeartFill',
    Home: 'Home',
    HomeFill: 'HomeFill',
    hourglass: 'hourglass',
    Icon: 'No Icon',
    InfographicsChart: 'InfographicsChart',
    InfographicsChartFill: 'InfographicsChartFill',
    Insert: 'Insert',
    Invite: 'Invite',
    Keyboard: 'Keyboard',
    KeyEnter: 'KeyEnter',
    Label: 'Label',
    LabelOff: 'LabelOff',
    layerGroupFill: 'layerGroupFill',
    LetterBig: 'LetterBig',
    LetterMedium: 'LetterMedium',
    LetterSmall: 'LetterSmall',
    Lightbulb: 'Lightbulb',
    Lightning: 'Lightning',
    Link: 'Link',
    Linkedin: 'Linkedin',
    LinkOff: 'LinkOff',
    List: 'List',
    ListCross: 'ListCross',
    ListEye: 'ListEye',
    ListGear: 'ListGear',
    ListNumbers: 'ListNumbers',
    ListPen: 'ListPen',
    ListPlus: 'ListPlus',
    Lobby: 'Lobby',
    Locked: 'Locked',
    LockedOff: 'LockedOff',
    Login: 'Login',
    Logout: 'Logout',
    MagicWand: 'MagicWand',
    MailEnvelope: 'MailEnvelope',
    MailEnvelopeFill: 'MailEnvelopeFill',
    Megaphone: 'Megaphone',
    Menu: 'Menu',
    Message: 'Message',
    Microphone: 'Microphone',
    MicrophoneOff: 'MicrophoneOff',
    Minimize: 'Minimize',
    Minus: 'Minus',
    MinusSmall: 'MinusSmall',
    Move: 'Move',
    MoveArrows: 'MoveArrows',
    MoveUpDown: 'MoveUpDown',
    Multiselect: 'Multiselect',
    MultiselectFill: 'MultiselectFill',
    Notification: 'Notification',
    Paint: 'Paint',
    Pan: 'Pan',
    PanelResize: 'PanelResize',
    PanelResizeLeft: 'PanelResizeLeft',
    PanelResizeRight: 'PanelResizeRight',
    Party: 'Party',
    Paste: 'Paste',
    Path: 'Path',
    Pencil: 'Pencil',
    Phone: 'Phone',
    PhoneCall: 'PhoneCall',
    PhoneEnd: 'PhoneEnd',
    Photo: 'Photo',
    PhotoFolder: 'PhotoFolder',
    PhotoGallery: 'PhotoGallery',
    PhotoOff: 'PhotoOff',
    PhotoPlus: 'PhotoPlus',
    Photos: 'Photos',
    PhotosFill: 'PhotosFill',
    Pin: 'Pin',
    PinOff: 'PinOff',
    PinStraight: 'PinStraight',
    PlayerFastForward: 'PlayerFastForward',
    PlayerMute: 'PlayerMute',
    PlayerPause: 'PlayerPause',
    PlayerPauseCircle: 'PlayerPauseCircle',
    PlayerPlay: 'PlayerPlay',
    PlayerPlayCircle: 'PlayerPlayCircle',
    PlayerPlayFilled: 'PlayerPlayFilled',
    PlayerPlaylist: 'PlayerPlaylist',
    PlayerRewind: 'PlayerRewind',
    PlayerSound: 'PlayerSound',
    PlayerSquareRecordStop: 'PlayerSquareRecordStop',
    Plus: 'Plus',
    PlusSmall: 'PlusSmall',
    Presentation: 'Presentation',
    'Presentation-1': 'Presentation-1',
    PresentationCheck: 'PresentationCheck',
    PresentationCross: 'PresentationCross',
    PresentationFill: 'PresentationFill',
    PresentationInfographics: 'PresentationInfographics',
    PresentationPlus: 'PresentationPlus',
    PresentationStop: 'PresentationStop',
    PresentationUser: 'PresentationUser',
    Product: 'Product',
    ProductOff: 'ProductOff',
    QrCode: 'QrCode',
    QueestionMark: 'QueestionMark',
    RadioChecked: 'RadioChecked',
    RadioUnchecked: 'RadioUnchecked',
    Redo: 'Redo',
    Refresh: 'Refresh',
    Repeat: 'Repeat',
    Replace: 'Replace',
    Reset: 'Reset',
    Robot: 'Robot',
    RobotFill: 'RobotFill',
    Rocket: 'Rocket',
    RocketFill: 'RocketFill',
    Rotate: 'Rotate',
    Ruler: 'Ruler',
    Save: 'Save',
    ScaleDown: 'ScaleDown',
    ScaleUp: 'ScaleUp',
    Screen: 'Screen',
    Search: 'Search',
    Season: 'Season',
    seedling: 'seedling',
    SelectArrow: 'SelectArrow',
    SelectPlus: 'SelectPlus',
    Send: 'Send',
    ShapeArrow: 'ShapeArrow',
    ShapeCircle: 'ShapeCircle',
    ShapeLine: 'ShapeLine',
    Shapes: 'Shapes',
    ShapeSquare: 'ShapeSquare',
    ShapeSquareRounded: 'ShapeSquareRounded',
    ShapeTriangle: 'ShapeTriangle',
    Share: 'Share',
    ShareNetwork: 'ShareNetwork',
    ShareScreen: 'ShareScreen',
    ShareScreenStop: 'ShareScreenStop',
    Shirt: 'Shirt',
    ShirtArrow: 'ShirtArrow',
    ShirtCircleDashed: 'ShirtCircleDashed',
    ShirtCircleSolid: 'ShirtCircleSolid',
    ShirtDimensions: 'ShirtDimensions',
    ShirtEye: 'ShirtEye',
    ShirtGrid: 'ShirtGrid',
    ShirtInfo: 'ShirtInfo',
    ShirtPlus: 'ShirtPlus',
    ShirtSearch: 'ShirtSearch',
    ShirtStacked: 'ShirtStacked',
    ShirtWidth: 'ShirtWidth',
    ShoppingBag: 'ShoppingBag',
    ShoppingCart: 'ShoppingCart',
    ShoppingCartFill: 'ShoppingCartFill',
    ShoppingCheckmark: 'ShoppingCheckmark',
    ShoppingCog: 'ShoppingCog',
    ShoppingPlus: 'ShoppingPlus',
    SideArrowLeft: 'SideArrowLeft',
    SideArrowLeftRight: 'SideArrowLeftRight',
    SideArrowRight: 'SideArrowRight',
    SizeCurveChart: 'SizeCurveChart',
    Slide: 'Slide',
    squaresDifference: 'squaresDifference',
    squaresOverlap: 'squaresOverlap',
    Stack: 'Stack',
    stampAI: 'stampAI',
    stampCheck: 'stampCheck',
    Star: 'Star',
    StarFilled: 'StarFilled',
    StarSparkles: 'StarSparkles',
    Stock: 'Stock',
    StockEye: 'StockEye',
    StockFill: 'StockFill',
    StockMinus: 'StockMinus',
    StockOff: 'StockOff',
    StockPlus: 'StockPlus',
    StockSearch: 'StockSearch',
    store: 'store',
    storeEye: 'storeEye',
    storePlus: 'storePlus',
    Switch: 'Switch',
    Table: 'Table',
    TableColumns: 'TableColumns',
    TableGear: 'TableGear',
    Tablet: 'Tablet',
    TableTabs: 'TableTabs',
    Target: 'Target',
    TeamMembers: 'TeamMembers',
    TeamMembersFill: 'TeamMembersFill',
    Template: 'Template',
    Text: 'Text',
    TextAlignCenter: 'TextAlignCenter',
    TextAlignLeft: 'TextAlignLeft',
    TextAlignRight: 'TextAlignRight',
    Trash: 'Trash',
    TrashEmpty: 'TrashEmpty',
    TrashRestore: 'TrashRestore',
    Twitter: 'Twitter',
    Undo: 'Undo',
    Ungroup: 'Ungroup',
    Upload: 'Upload',
    User: 'User',
    UserSearch: 'UserSearch',
    Video: 'Video',
    VideoCamera: 'VideoCamera',
    VideoCameraOff: 'VideoCameraOff',
    ViewColumns: 'ViewColumns',
    ViewGrid: 'ViewGrid',
    ViewRows: 'ViewRows',
    Wave: 'Wave',
    WrenchTools: 'WrenchTools',
    ZoomMinus: 'ZoomMinus',
    ZoomPlus: 'ZoomPlus'
} as const;

export type IconName = keyof typeof IconNameMap;
